export default __webpack_public_path__ + "static/media/icn-phone.3633b801.svg";